import React from "react";
import { Card, CardContent, Grid } from "@material-ui/core";
import CustomerInfo from "./view/_customer_info";
import AccountInfo from "./view/_account_info";

export default function E_CustomerProfile() {
  return (
    <CardContent>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        direction="row"
        spacing={2}
      >
        <Grid item xs={12}>
          <CustomerInfo />
        </Grid>
        <Grid item xs={12}>
          <AccountInfo />
        </Grid>
      </Grid>
    </CardContent>
  );
}
